import React from 'react';
import { Link } from 'react-router-dom';
import { FaSignInAlt } from 'react-icons/fa';
import './Homepage.css';

const Homepage = () => (
  <div className="homepage-container">
    <h1 className="homepage-title">Hahum</h1>
    <Link to="/portal">
      <button className="homepage-button">
        <FaSignInAlt />
      </button>
    </Link>
  </div>
);

export default Homepage;
